import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { PuntoIntermedio, ResumenTareasService } from 'src/app/services/resumen-tareas.service';
import { HttpClient } from '@angular/common/http';

import { decode } from '@here/flexpolyline'
import { MatDialog } from '@angular/material/dialog';
import { PlaceDetailDialogComponent } from 'src/app/place-detail-dialog/place-detail-dialog.component';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

declare var google: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
interface PuntoRuta {
  texto: string;
  sugerencias: any[];
  detalle: any;
  cargando: boolean;
    tareas: Tarea[];
      usarCoordenadas: boolean;
        lat?: number;
  lng?: number;
}



interface PuntoRutaTramo {
  coordenadas: string;
  tareas: any[]; 
}

interface Tarea {
  titulo: string;
  detalle: string;
  horas: number;
  minutos: number;
}

interface Parada {
  desde: string;
  hasta: string;
  distancia: string;
  duracion: string;
  peaje: number;
  tipoParada: string;
  horaIngreso: string;
  horaSalida: string;
  horaLlegada: string;
  ventanaHoraria: string;
  acumuladoInicio: string;
  acumuladoFinal: string;
  tiempoJornada: string;
  tiempoConduccion: string;
  tiempoSinDescanso: string;
  justificacion?: string; // <- opcional
}

interface Peaje {
  countryCode: string;
  tollSystemRef: number;
  tollSystem: string;
  tollSystems: number[];
  fares: TarifaPeaje[];
  tollCollectionLocations: UbicacionPeaje[];
}

interface TarifaPeaje {
  id: string;
  name: string;
  price: PrecioPeaje;
  reason: string;
  paymentMethods: string[];
  pass?: PasajePeaje; // Opcional
}

interface PrecioPeaje {
  type: string;
  currency: string;
  value: number;
}

interface UbicacionPeaje {
  name: string;
  location: CoordenadasPeaje;
}

interface CoordenadasPeaje {
  lat: number;
  lng: number;
}

interface PasajePeaje {
  returnJourney: boolean;
  validityPeriod: PeriodoValidez;
}

interface PeriodoValidez {
  period: string;
  count: number;
}

interface PasoRuta {
  direccion: string;
  distancia: {
    text: string;
    value: number;
  };
  duracion: {
    text: string;
    value: number;
  };
  ubicacion_inicio: {
    lat: number;
    lng: number;
  };
  ubicacion_fin: {
    lat: number;
    lng: number;
  };
  instrucciones: string;
  modo_viaje: string;
  polyline: string;
}

interface PuntoDestino {
  detalle?: any;
  texto?: string;
  tareas?: Tarea[];
  usarCoordenadas?: boolean;
  lat?: number;
  lng?: number;
}


@Component({
  selector: 'app-FragmentMapaPlanificador',
  templateUrl: './FragmentMapaPlanificador.component.html', // Usa solo templateUrl
  styleUrls: ['./FragmentMapaPlanificador.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class FragmentMapaPlanificador implements AfterViewInit  {
  @ViewChild('mapContainer', { static: false }) mapContainer: ElementRef;
 textoBusqueda = '';
  origen: string = '';
  puntoIntermedio: string = '';
 destino: PuntoDestino = {
  tareas: [],
  usarCoordenadas: false
};
  cargando: boolean = false;

  rutaGenerada: boolean = false;
  raddonId: string = "";
  resumenRuta: any = null;
  listaPeajes: any[] = [];
googlePolylineRuta: any; // la nueva polyline
googleTramoMarkers: any[] = []; // marcadores de tramos (inicio y fin de cada leg)
  googleMap: any;
  polylineRuta: any;
  marcadores: any[] = [];
fechaInicio: Date = new Date();;
  tollMarkers: any[] = [];
resultadoPlanRuta: any[] = [];
respuestaCruda: string = '';
  marcadoresGoogle: any[] = [];
  tollMarkersGoogle: any[] = [];
rodamiento24Horas: boolean = false;
  numeroConductores: number = 1;
  totalDistanciaKm: number = 0;
totalDuracionMin: number = 0;
totalPeajes: number = 0;
  texto = '';
  origenTexto: string = '';
   distanciaTotal   = 0.0;
  origenDetalle: any = null;
sugerenciasOrigen: any[] = [];
peajesConDetalle: any[] = [];
cargandoOrigen = false;
valoresGuardados = false;
mapaVelocidades: { [key: string]: number } = {
  'Subida con curvas': 25,
  'Bajada': 20,
  'Plano': 40,
  'Mixto': 30
};
 marcadoresRutas: google.maps.Marker[] = []; // Array para almacenar marcadores

mostrarRutas = false;
codigoIngresado = ''; // Campo vinculado al input
// Valores por defecto
mapaVelocidadesDefault: { [key: string]: number } = {
  'Subida con curvas': 25,
  'Bajada': 20,
  'Plano': 40,
  'Mixto': 30
};
 codigoAprobacion = '232323'; // Código quemado temporalmente
  puntosIntermedios: PuntoRuta[] = [];
horaInicioJornada: string = '04:00';
horaInicioRodamiento: string = '05:00';
horaFinRodamiento: string = '23:00';
pasosTotales: any[] = [];
  usarCoordenadasOrigen: boolean = false;
activarTanqueo: boolean = false;
tiempoTanqueo: number = 0;
usarCoordenadasDestino: boolean = false;
destinoLat: number = 0;
destinoLng: number = 0;
  origenLat: number = 0;
  origenLng: number = 0

  horasCarga: number = 0
  destinoTexto: string = '';
  destinoDetalle: any = null;
  sugerenciasDestino: any[] = [];
  cargandoDestino: boolean = false;
  maxTiempoSinDescanso: number = 4;    // Horas
maxConduccionDiaria: number = 10;    // Horas
maxJornadaDiaria: number = 14;    
 rutas: any[] = [];
  polylineHere: string[] = []
  markers: google.maps.Marker[] = [];

  mostrarPanelPeajes: boolean = true;
marcadorPeaje: google.maps.Marker | null = null;
  readonly apiKeyHere = '9oZR5QIeDIOZJgusBRD1JLI-qo-n4vq5cH5dFLINodc';

  constructor(private http: HttpClient, private resumenTareasService :ResumenTareasService,private dialog: MatDialog) {}

  ngAfterViewInit() {
    this.googleMap = new google.maps.Map(this.mapContainer.nativeElement, {
      center: { lat: 6.2442, lng: -75.5812 },
      zoom: 6
    });

  }

toggleRutas() {
  if (this.mostrarRutas) {
    // Si está marcado, carga las rutas en el mapa
    this.loadRutas();
  } else {
    // Si está desmarcado, elimina las rutas del mapa
    this.clearRutasMarkers();
  }
}

  togglePeajesPanel() {
  this.mostrarPanelPeajes = !this.mostrarPanelPeajes;
}

// Función para calcular el total de peajes
calcularTotalPeajes(): number {
  return this.peajesConDetalle.reduce((total, peaje) => total + (peaje.valor_tarifa || 0), 0);
}

// Función para ver el peaje en el mapa
verPeajeEnMapa(peaje: any): void {
  this.mostrarPanelPeajes = true;
  
 
    const mapsUrl = `https://www.google.com/maps?q=${peaje.latitud},${peaje.longitud}` +
                    `&ll=${peaje.latitud},${peaje.longitud}` +
                    `&z=15` + // Nivel de zoom
                    `&t=m`;   // Tipo de mapa (m = mapa normal, k = satélite)
    
    window.open(mapsUrl, '_blank')
}

// Función para copiar coordenadas al portapapeles
copiarCoordenadas(peaje: any): void {
  const coords = `${peaje.latitud}, ${peaje.longitud}`;
  navigator.clipboard.writeText(coords).then(() => {
   
  });
}


guardarVelocidades() {
  if (this.codigoIngresado === this.codigoAprobacion) {
    console.log('✅ Velocidades guardadas:', this.mapaVelocidades);
   alert('✅ El cambio de velocidad se realizó con éxito.');
       this.valoresGuardados = true;
  } else {
    alert('⚠️ Código incorrecto. Se restablecen los valores originales.');
    console.warn('❌ Código incorrecto. Se restablecen valores.');
    this.restablecerVelocidades();
  }
}

restablecerVelocidades() {
  this.mapaVelocidades = { ...this.mapaVelocidadesDefault };
  this.codigoIngresado = '';
  this.valoresGuardados = false;
}

  getDistanciaFormateada(): string {
  return this.totalDistanciaKm.toFixed(1).replace('.', ',') + ' km';
}
getDistanciaRectaFormateada(): string {
  const km = this.distanciaTotal / 1000;
  return km.toFixed(1).replace('.', ',') + ' km';
}

transformarPeajes(peajesCrudos: any[]): any[] {
  return peajesCrudos.map(peaje => {
    const primerPeaje = peaje.tollCollectionLocations && peaje.tollCollectionLocations[0] 
      ? peaje.tollCollectionLocations[0] 
      : { name: 'desconocido', location: { lat: 0, lng: 0 } };
    
    const primeraTarifa = peaje.fares && peaje.fares[0] 
      ? peaje.fares[0] 
      : { 
          name: 'desconocido', 
          price: { type: 'value', currency: 'COP', value: 0 },
          reason: 'toll'
        };
    
    return {
      pais: peaje.countryCode || 'COL',
      sistema_peaje: peaje.tollSystem || 'desconocido',
      ubicacion: primerPeaje.name,
      latitud: primerPeaje.location ? primerPeaje.location.lat : 0,
      longitud: primerPeaje.location ? primerPeaje.location.lng : 0,
      tarifa_nombre: primeraTarifa.name,
      valor_tarifa: primeraTarifa.price ? primeraTarifa.price.value : 0,
      moneda: primeraTarifa.price ? primeraTarifa.price.currency : 'COP',
      metodos_pago: primeraTarifa.paymentMethods 
        ? primeraTarifa.paymentMethods.join(', ') 
        : 'cash',
      valido_retorno: primeraTarifa.pass 
        ? (primeraTarifa.pass.returnJourney ? 'sí' : 'no') 
        : 'no aplica',
      periodo_validez: primeraTarifa.pass && primeraTarifa.pass.validityPeriod
        ? `${primeraTarifa.pass.validityPeriod.count} ${primeraTarifa.pass.validityPeriod.period}`
        : 'no aplica'
    };
  });
}

async transformarPeajesConsulta(peajesCrudos: any[]): Promise<any[]> {
  const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  const peajesTransformados = await Promise.all(
    peajesCrudos.map(async (peaje, index) => {
      // ⏱ Esperar 5 segundos antes de cada petición (excepto la primera)
      if (index > 0) {
        await delay(3000);
      }

      const primerPeaje = peaje.tollCollectionLocations && peaje.tollCollectionLocations.length > 0
        ? peaje.tollCollectionLocations[0]
        : { name: 'desconocido', location: { lat: 0, lng: 0 } };

      const primeraTarifa = peaje.fares && peaje.fares.length > 0
        ? peaje.fares[0]
        : { 
            name: 'desconocido', 
            price: { type: 'value', currency: 'COP', value: 0 },
            reason: 'toll'
          };

      // ✅ Llamada al servicio Angular que consume searchToll
      let datosGoogle: any = null;
      try {
        const data: any = await this.resumenTareasService
          .getSearchToll(primerPeaje.location.lat, primerPeaje.location.lng, 2000)
          .toPromise(); // Convertir Observable a Promise para usar con await

        if (data && data.results && data.results.length > 0) {
          datosGoogle = data.results[0];
        }
      } catch (error) {
        console.warn(`Error consultando searchToll para ${primerPeaje.name}:`, error.message);
      }

      return {
        pais: peaje.countryCode ? peaje.countryCode : 'COL',
        sistema_peaje: peaje.tollSystem ? peaje.tollSystem : 'desconocido',
        ubicacion: primerPeaje.name,
        latitud: primerPeaje.location && primerPeaje.location.lat ? primerPeaje.location.lat : 0,
        longitud: primerPeaje.location && primerPeaje.location.lng ? primerPeaje.location.lng : 0,
        tarifa_nombre: primeraTarifa.name,
        valor_tarifa: primeraTarifa.price && primeraTarifa.price.value ? primeraTarifa.price.value : 0,
        moneda: primeraTarifa.price && primeraTarifa.price.currency ? primeraTarifa.price.currency : 'COP',
        metodos_pago: primeraTarifa.paymentMethods ? primeraTarifa.paymentMethods.join(', ') : 'cash',
        valido_retorno: primeraTarifa.pass 
          ? (primeraTarifa.pass.returnJourney ? 'sí' : 'no') 
          : 'no aplica',
        periodo_validez: primeraTarifa.pass && primeraTarifa.pass.validityPeriod
          ? `${primeraTarifa.pass.validityPeriod.count} ${primeraTarifa.pass.validityPeriod.period}`
          : 'no aplica',

        // 🔥 Datos enriquecidos desde Google Places
        google_place_name: datosGoogle && datosGoogle.name ? datosGoogle.name : null,
        google_rating: datosGoogle && datosGoogle.rating ? datosGoogle.rating : null,
        google_address: datosGoogle && datosGoogle.address ? datosGoogle.address : null,
        google_place_id: datosGoogle && datosGoogle.place_id ? datosGoogle.place_id : null
      };
    })
  );

  console.log("Peajes::", peajesTransformados);
  this.peajesConDetalle = peajesTransformados;
  return peajesTransformados;
}




aprobarPlan() {
  console.log('✅ Plan aprobado');

  const datosRuta = this.getDatosFormularioParaExportacion();

  this.resumenTareasService.createRutaViajero(datosRuta).subscribe({
    next: (response) => {
      console.log('🚀 Ruta enviada createRutaViajero:', response);
          this.loadRutas()
    },
    error: (err) => {
      console.error('❌ Error al enviar la createRutaViajero:', err);
    }
  });

  
  this.resumenTareasService.createRutaViajeroPlanilla(this.resumenRuta.tramos, this.raddonId).subscribe({
    next: (response) => {
      console.log('🚀 Ruta enviada createRutaViajeroPlanilla:', response);
    },
    error: (err) => {
      console.error('❌ Error al enviar la createRutaViajeroPlanilla:', err);
    }
  });
  

  this.resumenTareasService.createRutaViajeroPeajes(this.transformarPeajes(this.listaPeajes), this.raddonId).subscribe({
    next: (response) => {
      console.log('🚀 Ruta enviada createRutaViajeroPeajes:', response);
    },
    error: (err) => {
      console.error('❌ Error al enviar la createRutaViajeroPeajes:', err);
    }
  });

    this.resumenTareasService.createHereViajero(this.polylineHere, this.raddonId).subscribe({
    next: (response) => {
      console.log('🚀 Ruta enviada createRutaViajeroPeajes:', response);
    },
    error: (err) => {
      console.error('❌ Error al enviar la createRutaViajeroPeajes:', err);
    }
  });

    const pasosTransformados = this.transformarPasos(this.pasosTotales);
  
  const data = pasosTransformados.map(paso => ({
    'Direccion': paso.direccion,
    'Distancia_texto': paso.distancia.text,
    'Distancia_metros': paso.distancia.value,
    'Duracion_texto': paso.duracion.text,
    'Duracion_segundos': paso.duracion.value,
    'Latitud_Inicio': paso.ubicacion_inicio.lat,
    'Longitud_Inicio': paso.ubicacion_inicio.lng,
    'Latitud_Fin': paso.ubicacion_fin.lat,
    'Longitud_Fin': paso.ubicacion_fin.lng,
    'Instrucciones': paso.instrucciones,
    'Modo_de_Viaje': paso.modo_viaje,
    'Polyline': paso.polyline
  }));


  this.resumenTareasService.createRutaViajeroDetalle(data, this.raddonId).subscribe({
    next: (response) => {
      console.log('🚀 Ruta enviada createRutaViajeroPeajes:', response);
    },
    error: (err) => {
      console.error('❌ Error al enviar la createRutaViajeroPeajes:', err);
    }
  });

  /*
  this.resumenTareasService.createRutaViajeroDetalle(this.exportarDetalleRutaCompleto()).subscribe({
    next: (response) => {
      console.log('🚀 Ruta enviada createRutaViajeroDetalle:', response);
    },
    error: (err) => {
      console.error('❌ Error al enviar la createRutaViajeroDetalle:', err);
    }
  });
  */
  // Aquí puedes agregar más lógica después del envío si necesitas
}


verDetalleLugar(detalle: any) {
  this.dialog.open(PlaceDetailDialogComponent, {
    width: '600px',
    data: detalle // o cualquier variable donde guardes el detalle
  });
}


// Para el origen (ya lo tienes)
buscarOrigen() {
  if (!this.origenTexto || this.origenTexto.length < 5) {
    this.sugerenciasOrigen = [];
    return;
  }

  this.cargandoOrigen = true;
  this.sugerenciasOrigen = [];

  this.resumenTareasService.buscarLugares(this.origenTexto).subscribe({
    next: (res) => {
      this.sugerenciasOrigen = res;
      this.cargandoOrigen = false;
    },
    error: () => {
      this.sugerenciasOrigen = [];
      this.cargandoOrigen = false;
    }
  });
}

// Para puntos intermedios
buscarIntermedio(index: number) {
  const punto = this.puntosIntermedios[index];
  
  if (!punto.texto || punto.texto.length < 5) {
    punto.sugerencias = [];
    return;
  }

  punto.cargando = true;
  punto.sugerencias = [];

  this.resumenTareasService.buscarLugares(punto.texto).subscribe({
    next: (res) => {
      punto.sugerencias = res;
      punto.cargando = false;
    },
    error: () => {
      punto.sugerencias = [];
      punto.cargando = false;
    }
  });
}

// Para el destino
buscarDestino() {
  if (!this.destinoTexto || this.destinoTexto.length < 5) {
    this.sugerenciasDestino = [];
    return;
  }

  this.cargandoDestino = true;
  this.sugerenciasDestino = [];

  this.resumenTareasService.buscarLugares(this.destinoTexto).subscribe({
    next: (res) => {
      this.sugerenciasDestino = res;
      this.cargandoDestino = false;
    },
    error: () => {
      this.sugerenciasDestino = [];
      this.cargandoDestino = false;
    }
  });
}

transformarPasos(pasosCrudos: any[]): PasoRuta[] {
  return pasosCrudos.map(paso => ({
    direccion: paso.direccion || 'Sin dirección',
    distancia: {
      text: paso.distance.text || '0 m',
      value: paso.distance.value || 0
    },
    duracion: {
      text: paso.duration.text || '0 min',
      value: paso.duration.value || 0
    },
    ubicacion_inicio: {
      lat: paso.start_location.lat || 0,
      lng: paso.start_location.lng || 0
    },
    ubicacion_fin: {
      lat: paso.end_location.lat || 0,
      lng: paso.end_location.lng || 0
    },
    instrucciones: this.limpiarInstrucciones(paso.html_instructions) || 'Sin instrucciones',
    modo_viaje: paso.travel_mode || 'DRIVING',
    polyline: paso.polyline.points || ''
  }));
}

private limpiarInstrucciones(html: string): string {
  // Eliminar etiquetas HTML y caracteres especiales
  return html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ') || '';
}

exportarDetalleRutaCompleto() {
  const pasosTransformados = this.transformarPasos(this.pasosTotales);
  
  const data = pasosTransformados.map(paso => ({
    'Direccion': paso.direccion,
    'Distancia_texto': paso.distancia.text,
    'Distancia_metros': paso.distancia.value,
    'Duracion_texto': paso.duracion.text,
    'Duracion_segundos)': paso.duracion.value,
    'Latitud_Inicio': paso.ubicacion_inicio.lat,
    'Longitud_Inicio': paso.ubicacion_inicio.lng,
    'Latitud_Fin': paso.ubicacion_fin.lat,
    'Longitud_Fin': paso.ubicacion_fin.lng,
    'Instrucciones': paso.instrucciones,
    'Modo_de_Viaje': paso.modo_viaje,
    'Polyline': paso.polyline
  }));

  this.exportAsExcelFile(data, this.generarNombreArchivo('detalle_ruta_completa'));
}

seleccionarOrigen(lugar: any) {
  this.origenTexto = lugar.descripcion;
  this.origen = lugar.descripcion;
  this.sugerenciasOrigen = [];

  // Consumir detalle completo
  this.resumenTareasService.detalleLugar(lugar.place_id).subscribe({
    next: (res) => {
      this.origenDetalle = res;
      console.log('📍 Detalle del origen:', this.origenDetalle);
      // Aquí puedes guardar lat/lng, dirección, etc.
    },
    error: (err) => {
      console.error('Error al obtener detalle del lugar', err);
    }
  });
}

formatearHora(date: Date): string {
  const h = date.getHours();
  const m = date.getMinutes();
  const hora = h % 12 || 12;
  const ampm = h < 12 ? 'AM' : 'PM';
  const minutos = m < 10 ? '0' + m : m;
  return `${hora}:${minutos} ${ampm}`;
}

asignarHorasEstimadas(tramos: any[]) {
  let horaActual = new Date();
  horaActual.setHours(6, 0, 0, 0); // Salida: 6:00 AM

  for (let tramo of tramos) {
    tramo.horaSalida = this.formatearHora(new Date(horaActual));

    // Parsear duración
    const duracion = tramo.duracion; // ej: "1h 30 min" o "20 min"
    const regex = /(?:(\d+)h)?\s*(\d+)?\s*min?/;
    const match = duracion.match(regex);

    let horas = match && match[1] ? parseInt(match[1]) : 0;
    let minutos = match && match[2] ? parseInt(match[2]) : 0;

    horaActual.setHours(horaActual.getHours() + horas);
    horaActual.setMinutes(horaActual.getMinutes() + minutos);

    tramo.horaLlegada = this.formatearHora(new Date(horaActual));

    // Ventana horaria
    tramo.ventanaHoraria = `${tramo.horaSalida} - ${tramo.horaLlegada}`;
  }
}

getCantidadDescansos(): number {
  if (
    this.resumenRuta &&
    this.resumenRuta.tramos &&
    Array.isArray(this.resumenRuta.tramos)
  ) {
    return this.resumenRuta.tramos.filter(function (tramo) {
      return tramo.tipoParada === 'Descanso';
    }).length;
  }
  return 0;
}

agregarTarea(puntoIndex: number) {
  this.puntosIntermedios[puntoIndex].tareas.push({
    titulo: '',
    detalle: '',
    horas: 0,
    minutos: 0
  });
}

eliminarTarea(puntoIndex: number, tareaIndex: number) {
  this.puntosIntermedios[puntoIndex].tareas.splice(tareaIndex, 1);
}

// Agrega un nuevo punto vacío
agregarPuntoIntermedio() {
  this.puntosIntermedios.push({
    texto: '',
    sugerencias: [],
    detalle: null,
    cargando: false,
    tareas: [],
  usarCoordenadas: false
  });
}

// Seleccionar intermedio
seleccionarIntermedio(index: number, sugerencia: any) {
  const punto = this.puntosIntermedios[index];
  punto.cargando = true;

  this.resumenTareasService.detalleLugar(sugerencia.place_id).subscribe({
    next: (res) => {
      punto.detalle = res;
      punto.texto = res.result.formatted_address;
      punto.sugerencias = [];
      punto.cargando = false;
    },
    error: () => {
      punto.cargando = false;
    }
  });
}

seleccionarDestino(sugerencia: any) {
  this.cargandoDestino = true;
  this.resumenTareasService.detalleLugar(sugerencia.place_id).subscribe({
    next: (res) => {
      this.destinoDetalle = res;
      this.destinoTexto = res.result.formatted_address;
      this.sugerenciasDestino = [];
      this.cargandoDestino = false;
    },
    error: () => {
      this.cargandoDestino = false;
    }
  });
}
// Eliminar punto intermedio
eliminarPuntoIntermedio(index: number) {
  this.puntosIntermedios.splice(index, 1);
}


calcularRuta(): void {
  this.distanciaTotal = 0.0;
   this.polylineHere = []

  if ((!this.usarCoordenadasOrigen && !this.origenDetalle) || (!this.usarCoordenadasDestino && !this.destinoDetalle)) {
    alert('Debe seleccionar tanto el origen como el destino');
    return;
  }

  const origenCoord = this.extraerCoordenadas(this.origenDetalle, this.usarCoordenadasOrigen, this.origenLat, this.origenLng);
  const destinoCoord = this.extraerCoordenadas(this.destinoDetalle, this.usarCoordenadasDestino, this.destinoLat, this.destinoLng); // destino siempre viene del API

  const puntos: PuntoRutaTramo[] = [];

  // Agregar origen
  puntos.push({
    coordenadas: origenCoord,
    tareas: []
  });

  // Agregar puntos intermedios con sus tareas
 this.puntosIntermedios.forEach(p => {
      if (p) {
    
        var coordenadas= ""
        if (p.usarCoordenadas) {
          // Usar coordenadas manuales para punto intermedio
          if (!p.lat || !p.lng) {
            throw new Error(`Faltan coordenadas para el punto intermedio`);
          }
          coordenadas = this.extraerCoordenadas(p.detalle, true, p.lat, p.lng);
        } else {
          // Usar coordenadas de API para punto intermedio
          if (!p.detalle) {
            throw new Error(`Falta seleccionar ubicación para el punto intermedio`);
          }
          coordenadas = this.extraerCoordenadas(p.detalle, false, 0, 0);
        }

        puntos.push({
          coordenadas: coordenadas,
          tareas: p.tareas || []
        });
      }
    });

  // Agregar destino
  puntos.push({
    coordenadas: destinoCoord,
    tareas: []
  });

  // Procesar la ruta
  this.procesarRutaCompleta(puntos);
}
descargarRuta(): void {
  const tieneTramos = this.resumenRuta && Array.isArray(this.resumenRuta.tramos) && this.resumenRuta.tramos.length > 0;
  const tienePeajes = Array.isArray(this.listaPeajes) && this.listaPeajes.length > 0;

  if (!tieneTramos && !tienePeajes) {
    this.mostrarError('No hay datos para descargar');
    return;
  }

  if (tieneTramos) {
    this.exportAsExcelFile(this.resumenRuta.tramos, this.generarNombreArchivo('detalle_ruta'));
      this.exportAsExcelFile(this.getDatosFormularioParaExportacion(), this.generarNombreArchivo('ruta'));
  }

  if (tienePeajes) {
    this.exportAsExcelFile(this.peajesConDetalle, this.generarNombreArchivo('peajes'));
  }

  this.exportarDetalleRutaCompleto();
}

generateRaddonId(): string {
  const timestamp = Date.now().toString(36);
  const randomStr = Math.random().toString(36).substr(2, 6);
  return `${timestamp}-${randomStr}`; // Ej: "raddon-kf9xyr-8m3q"
}

private getDatosFormularioParaExportacion(): any[] {
 
  // Crear objeto base con todos los datos existentes
  const datosBase = {
    // Configuración básica
    'guia':this.raddonId,
    'fecha_inicio': this.fechaInicio || '',
    'hora_inicio_jornada': this.horaInicioJornada || '',
    'hora_inicio_rodamiento': this.horaInicioRodamiento || '',
    'hora_fin_rodamiento': this.horaFinRodamiento || '',
    'tiempo_tanqueo_h': this.tiempoTanqueo || '',
    'max_sin_descanso_h': this.maxTiempoSinDescanso || '',
    'max_conduccion_h': this.maxConduccionDiaria || '',
    'max_jornada_h': this.maxJornadaDiaria || '',
    'negocio': localStorage.getItem("negocio")|| '',
    'agencia': localStorage.getItem("agencia")|| '',
    
    // Ubicaciones
    'origen': (this.origenDetalle && this.origenDetalle.result && this.origenDetalle.result.formatted_address) || this.origenTexto || '',
    'origen_latitud': (this.origenDetalle && this.origenDetalle.result && this.origenDetalle.result.geometry && this.origenDetalle.result.geometry.location && this.origenDetalle.result.geometry.location.lat) || '',
    'origen_longitud': (this.origenDetalle && this.origenDetalle.result && this.origenDetalle.result.geometry && this.origenDetalle.result.geometry.location && this.origenDetalle.result.geometry.location.lng) || '',
    
    'destino': (this.destinoDetalle && this.destinoDetalle.result && this.destinoDetalle.result.formatted_address) || this.destinoTexto || '',
    'destino_latitud': (this.destinoDetalle && this.destinoDetalle.result && this.destinoDetalle.result.geometry && this.destinoDetalle.result.geometry.location && this.destinoDetalle.result.geometry.location.lat) || '',
    'destino_longitud': (this.destinoDetalle && this.destinoDetalle.result && this.destinoDetalle.result.geometry && this.destinoDetalle.result.geometry.location && this.destinoDetalle.result.geometry.location.lng) || '',
    
    // Resumen de ruta
    'distancia_total': this.getDistanciaFormateada ? this.getDistanciaFormateada() : '',
    'duracion_total': this.getDuracionFormateada ? this.getDuracionFormateada() : '',
    'total_peajes': this.getPeajesFormateado ? this.getPeajesFormateado() : '',
    'paradas_descanso': this.getCantidadDescansos ? this.getCantidadDescansos() : '',
    'distancia_sin_desvios': this.getDistanciaRectaFormateada ? this.getDistanciaRectaFormateada() : '',
    'hora_salida': this.getFechaHoraSalida ? this.getFechaHoraSalida() : '',
    'hora_llegada': this.getFechaHoraLlegada ? this.getFechaHoraLlegada() : '',
    
    // Tareas del destino
    'destino_tareas': this.destino && this.destino.tareas && this.destino.tareas.length > 0 
      ? this.destino.tareas.map((t, i) => 
          `Tarea ${i+1}: ${t.titulo || 'Sin título'}\n` +
          `Descripción: ${t.detalle || 'Sin detalle'}\n` +
          `Duración: ${t.horas || 0}h ${t.minutos || 0}m`
        ).join('\n\n')
      : 'Sin tareas',
    
    // Fecha y hora de generación
    'reporte_generado_el': new Date().toLocaleString()
  };

  // Agregar puntos intermedios si existen
  const datosConPuntosIntermedios = {...datosBase};
  
  if (this.puntosIntermedios && this.puntosIntermedios.length > 0) {
    this.puntosIntermedios.forEach((punto, index) => {
      const numPunto = index + 1;
      const prefijo = `punto_intermedio_${numPunto}`;
      
      // Dirección
      datosConPuntosIntermedios[`${prefijo}_direccion`] = 
        (punto.detalle && punto.detalle.result && punto.detalle.result.formatted_address) || 
        (punto.usarCoordenadas ? 'Coordenadas manuales' : '') || 
        '';
      
      // Coordenadas
      datosConPuntosIntermedios[`${prefijo}_latitud`] = 
        (punto.detalle && punto.detalle.result && punto.detalle.result.geometry && 
         punto.detalle.result.geometry.location && punto.detalle.result.geometry.location.lat) || 
        punto.lat || 
        '';
      
      datosConPuntosIntermedios[`${prefijo}_longitud`] = 
        (punto.detalle && punto.detalle.result && punto.detalle.result.geometry && 
         punto.detalle.result.geometry.location && punto.detalle.result.geometry.location.lng) || 
        punto.lng || 
        '';
      
      // Tareas
      datosConPuntosIntermedios[`${prefijo}_tareas`] = 
        punto.tareas && punto.tareas.length > 0
          ? punto.tareas.map((t, i) => 
              `Tarea ${i+1}: ${t.titulo || 'Sin título'}\n` +
              `Descripción: ${t.detalle || 'Sin detalle'}\n` +
              `Duración: ${t.horas || 0}h ${t.minutos || 0}m`
            ).join('\n\n')
          : 'Sin tareas';
    });
  }

  return [datosConPuntosIntermedios];
}


getResumenRapido(): string {
  return `${this.getDistanciaFormateada()} • ${this.getDuracionFormateada()} • ${this.getPeajesFormateado()}`;
}


private obtenerRutaSegmento(origen: string, destino: string): Promise<{
  distancia: number;
  duracion: number;
  peajes: any[];
  polylinePoints: { lat: number; lng: number }[];
  polyline:string[];
}> {
  const url =
    'https://router.hereapi.com/v8/routes' +
    '?transportMode=truck' +
    '&origin=' + origen +
    '&destination=' + destino +
    '&return=summary,polyline,tolls' +
    '&apikey=' + this.apiKeyHere;

  return new Promise((resolve, reject) => {
    this.http.get(url).subscribe({
      next: function (data: any) {
        try {
          if (!data.routes || data.routes.length === 0) {
            reject('Ruta no encontrada');
            return;
          }

          console.log("here response : ", data)
          const route = data.routes[0];
          let distancia = 0;
          let duracion = 0;
          let peajes: any[] = [];
          let polylinePoints: { lat: number; lng: number }[] = [];
          let polylineSegments: string[] = []; // Array para almacenar cada polyline
          for (let section of route.sections || []) {
            
            if (section.summary) {
              distancia += section.summary.length || 0;
              duracion += section.summary.duration || 0;
            }

            if (section.tolls && section.tolls.length > 0) {
              peajes = peajes.concat(section.tolls);
            }
             polylineSegments.push(section.polyline);
  
   
            const decoded = decode(section.polyline);
            const points = decoded.polyline.map((pair: number[]) => ({
              lat: pair[0],
              lng: pair[1]
            }));
            polylinePoints = polylinePoints.concat(points);
          }

          resolve({ distancia, duracion, peajes, polylinePoints , polyline: polylineSegments});
        } catch (e) {
          reject('Error procesando respuesta de HERE');
        }
      },
      error: () => reject('Error consultando API de HERE')
    });
  });
}




getFechaHoraSalida(): string {
  if (!this.resumenRuta || !this.resumenRuta.tramos || this.resumenRuta.tramos.length === 0) {
    return '';
  }
  const primerTramo = this.resumenRuta.tramos[0];
  return this.getFechaFormateada() + ' ' + primerTramo.horaIngreso;
}

getFechaHoraLlegada(): string {
  if (!this.resumenRuta || !this.resumenRuta.tramos || this.resumenRuta.tramos.length === 0) {
    return '';
  }

  if (!this.fechaInicio) {
    return '';
  }

  const tramos = this.resumenRuta.tramos;
  const ultimoTramo = tramos[tramos.length - 1];
  const diasExtra = this.calcularDiasExtra(tramos);

  // Usar la fecha ingresada por el usuario como base
  const fechaBase = new Date(this.fechaInicio);
  const fechaFinal = this.sumarDias(fechaBase, diasExtra);

  return this.getFechaFormateada(fechaFinal) + ' ' + ultimoTramo.horaSalida;
}


getFechaFormateada(fecha?: Date): string {
  const f = fecha || this.fechaInicio;
  return f.toLocaleDateString('es-CO', {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
}

sumarDias(fecha: Date, dias: number): Date {
  const nueva = new Date(fecha);
  nueva.setDate(nueva.getDate() + dias);
  return nueva;
}

calcularDiasExtra(tramos: any[]): number {
  let dias = 0;
  let horaAnterior = this.convertirAHoras(tramos[0].horaIngreso);

  for (let i = 1; i < tramos.length; i++) {
    const horaActual = this.convertirAHoras(tramos[i].horaIngreso);
    if (horaActual < horaAnterior) {
      dias++;
    }
    horaAnterior = horaActual;
  }

  return dias;
}

convertirAHoras(horaMin: string): number {
  // Convierte "5:00 AM" o "17:00" a minutos desde las 00:00
  const partes = horaMin.split(':');
  if (partes.length < 2) return 0;
  let hora = parseInt(partes[0], 10);
  const minutos = parseInt(partes[1], 10);
  const ampm = horaMin.toLowerCase().includes('pm') ? 'pm' : 'am';

  if (ampm === 'pm' && hora < 12) hora += 12;
  if (ampm === 'am' && hora === 12) hora = 0;

  return hora * 60 + minutos;
}



private extraerCoordenadas(lugar: any, usarGeo: boolean, lat: number, lng: number): string {
  if (usarGeo) {
    return `${lat},${lng}`;
  } else {
    const loc = lugar.result.geometry.location;
    return `${loc.lat},${loc.lng}`;
  }
}


horaAMinutos(hora: string): number {
    if (!hora) return 0;
    const [h, m] = hora.split(':').map(Number);
    return h * 60 + m;
  }


agregarVentanasHorariasConDescanso(tramos: any[]): any[] {
  console.log("tramos", tramos);
  const resultado: any[] = [];

  let tiempoActual = this.horaAMinutos(this.horaInicioJornada);
  let tiempoConduccionAcumulado = 0;
  let tiempoLaboralAcumulado = 0;
  let tiempoConduccionDiario = 0;
  let tiempoSinDescanso = 0;
  let primerDia = true;
  let yaAjustandoHorario = false;
  let diaActual = 1;

  // 👨‍✈️ Gestión de conductores
  let conductorActual = 1;
  const NUM_CONDUCTORES = this.numeroConductores || 1;

  const MAX_TIEMPO_CONDUCCION_SEGMENTO = this.maxTiempoSinDescanso * 60;
  const MAX_TIEMPO_CONDUCCION_DIARIO = this.maxConduccionDiaria * 60;
  const MAX_TIEMPO_LABORAL = this.maxJornadaDiaria * 60;

  const HORA_INICIO_JORNADA = this.horaAMinutos(this.horaInicioRodamiento);
  const HORA_FIN_JORNADA = this.horaAMinutos(this.horaFinRodamiento);

  const formatHorasMin = (min: number): string => {
    const h = Math.floor(min / 60);
    const m = min % 60;
    if (h > 0 && m > 0) return `${h} h ${m} min`;
    if (h > 0) return `${h} h`;
    return `${m} min`;
  };

  const estaFueraDeHorario = (minutos: number): boolean => {
    if (this.rodamiento24Horas) return false; // ✅ Ignorar validación si está activo el check 24h
    return minutos < HORA_INICIO_JORNADA || minutos >= HORA_FIN_JORNADA;
  };

  const ajustarAInicioDiaSiguiente = () => {
    if (yaAjustandoHorario) return;
    yaAjustandoHorario = true;

    diaActual++;
    tiempoActual = HORA_INICIO_JORNADA;
    tiempoConduccionAcumulado = 0;
    tiempoConduccionDiario = 0;
    tiempoLaboralAcumulado = 0;
    tiempoSinDescanso = 0;

    agregarTareasIniciales();
    yaAjustandoHorario = false;
  };

  const agregarParada = (
    nombre: string,
    duracion: number,
    tipo: string,
    omitirValidacionHorario = false
  ) => {
    const horaInicio = tiempoActual;
    const horaFin = horaInicio + duracion;

    if (
      !omitirValidacionHorario &&
      tiempoConduccionDiario > 4 &&
      (estaFueraDeHorario(horaInicio) || estaFueraDeHorario(horaFin))
    ) {
      ajustarAInicioDiaSiguiente();
      return;
    }

    const parada: any = {
      desde: nombre,
      hasta: nombre,
      distancia: '0 km',
      duracion: formatHorasMin(duracion),
      peaje: 0,
      tipoParada: tipo,
      horaIngreso: this.formatHoraMin(horaInicio),
      horaSalida: this.formatHoraMin(horaFin),
      horaLlegada: this.formatHoraMin(horaFin),
      ventanaHoraria: `${this.formatHoraMin(horaInicio)} - ${this.formatHoraMin(horaFin)}`,
      acumuladoInicio: formatHorasMin(tiempoLaboralAcumulado),
      acumuladoFinal: formatHorasMin(tiempoLaboralAcumulado + duracion),
      tiempoJornada: formatHorasMin(tiempoLaboralAcumulado),
      tiempoConduccion: formatHorasMin(tiempoConduccionAcumulado),
      tiempoSinDescanso: formatHorasMin(tiempoSinDescanso),
      indicadorConduccionInicioMin: tiempoConduccionAcumulado,
      indicadorConduccionInicioFmt: formatHorasMin(tiempoConduccionAcumulado),
      indicadorJornadaInicioMin: tiempoLaboralAcumulado,
      indicadorJornadaInicioFmt: formatHorasMin(tiempoLaboralAcumulado),
      indicadorSinDescansoInicioMin: tiempoSinDescanso,
      indicadorSinDescansoInicioFmt: formatHorasMin(tiempoSinDescanso),
      indicadorConduccionFinMin: tipo !== "tarea" ? tiempoConduccionAcumulado + duracion : tiempoConduccionAcumulado,
      indicadorConduccionFinFmt: formatHorasMin(tipo !== "tarea" ? tiempoConduccionAcumulado + duracion : tiempoConduccionAcumulado),
      indicadorJornadaFinMin: tiempoLaboralAcumulado + duracion,
      indicadorJornadaFinFmt: formatHorasMin(tiempoLaboralAcumulado + duracion),
      indicadorSinDescansoFinMin: tiempoSinDescanso + duracion,
      indicadorSinDescansoFinFmt: formatHorasMin(tiempoSinDescanso + duracion),
      dia: diaActual,
      conductor: conductorActual
    };

    if (tipo === 'Stop') {
      if (nombre.toLowerCase().includes('diaria')) {
        parada.justificacion = `Se alcanzó el máximo de conducción diaria (${MAX_TIEMPO_CONDUCCION_DIARIO / 60} h).`;
      } else if (nombre.toLowerCase().includes('jornada')) {
        parada.justificacion = `Se alcanzó el máximo de jornada laboral (${MAX_TIEMPO_LABORAL / 60} h).`;
      } else if (nombre.toLowerCase().includes('fuera')) {
        parada.justificacion = `Se encuentra fuera del horario permitido (5:00 AM - 11:00 PM).`;
      }

      if (nombre.toLowerCase().includes('descanso') || nombre.toLowerCase().includes('pausa')) {
        tiempoConduccionAcumulado = 0;
        tiempoConduccionDiario = 0;
        tiempoSinDescanso = 0;
      }
    }

    resultado.push(parada);
    tiempoActual = horaFin;
    tiempoLaboralAcumulado += duracion;
  };

  const agregarTareasIniciales = () => {
    agregarParada('Inicio de jornada', 10, 'Inicio', primerDia);
    agregarParada('Inspección operativa', 30, 'Inicio', primerDia);
    if (primerDia) {
      if (this.horasCarga > 0) agregarParada('Cargue', this.horasCarga, 'Inicio', primerDia);
      if (this.tiempoTanqueo > 0) agregarParada('Tanqueo', this.tiempoTanqueo * 60, 'Inicio', primerDia);
      primerDia = false;
    }
  };

  agregarTareasIniciales();

  for (let i = 0; i < tramos.length; i++) {
    const tramo = { ...tramos[i] };
    const topografia = tramo.topografia || '';
    const mapaVelocidades = this.valoresGuardados ? this.mapaVelocidades : this.mapaVelocidadesDefault;
    tramo.velocidad = mapaVelocidades[topografia] || 0;

    let distanciaKm = 0;
    if (typeof tramo.distancia === 'string') {
      const match = tramo.distancia.match(/[\d.,]+/);
      if (match) distanciaKm = parseFloat(match[0].replace(',', '.'));
    }

    const calculoTiempo = tramo.velocidad > 0 ? (distanciaKm / tramo.velocidad) * 60 : 0;
    tramo.calculoTiempo = Math.round(calculoTiempo);

    if (tramo.tipo === "tarea") {
      tramo.tipoParada = "tarea";
      tramo.calculoTiempo = tramo.duracionnumero;
    } else {
      tramo.duracion = formatHorasMin(tramo.calculoTiempo);
    }

    let tiempoExtra = 0;
    const nuevoTiempoSinDescanso = tiempoSinDescanso + tramo.calculoTiempo;
    if (nuevoTiempoSinDescanso > MAX_TIEMPO_CONDUCCION_SEGMENTO) {
      tramo.conDescanso = true;
      tramo.justificacion = `Se superaron las ${this.maxTiempoSinDescanso} horas de conducción continua sin descanso. Se agregó una pausa de 20 minutos.`;
      tiempoExtra = 20;
    }

    let tiempoTotal = tramo.calculoTiempo + tiempoExtra;
    tramo.tiempoSumadoMin = tiempoTotal;
    tramo.tiempoSumadoFmt = formatHorasMin(tiempoTotal);

    let reinicio = true;

    // 🚩 Validar máximo de conducción diaria o jornada laboral
    if (
      (tiempoConduccionDiario + tiempoTotal) > MAX_TIEMPO_CONDUCCION_DIARIO ||
      (tiempoLaboralAcumulado + tiempoTotal) > MAX_TIEMPO_LABORAL
    ) {
      if (NUM_CONDUCTORES > 1) {
        // 👨‍✈️ Cambio de conductor cíclico
        conductorActual++;
        if (conductorActual > NUM_CONDUCTORES) {
          conductorActual = 1; // 🔄 Reinicia al primer conductor
        }

        agregarParada(`Cambio de conductor (Conductor ${conductorActual})`, 10, 'Cambio', true);
        tiempoConduccionAcumulado = 0;
        tiempoConduccionDiario = 0;
        tiempoLaboralAcumulado = 0;
        tiempoSinDescanso = 0;
      } else {
        // 💤 Si solo hay un conductor, debe descansar
        tramo.conDescanso = true;
        tramo.justificacion =
          (tiempoConduccionDiario + tiempoTotal) > MAX_TIEMPO_CONDUCCION_DIARIO
            ? `Se alcanzó el máximo de ${this.maxConduccionDiaria} horas de conducción diaria. Se requiere descanso hasta el día siguiente.`
            : `Se superó el límite de ${this.maxJornadaDiaria} horas de jornada laboral. Se debe iniciar nueva jornada al día siguiente.`;

        tiempoExtra = 480; // Descanso de 8 horas
        tiempoTotal = tramo.calculoTiempo + tiempoExtra;
        tramo.tiempoSumadoMin = tiempoTotal;
        tramo.tiempoSumadoFmt = formatHorasMin(tiempoTotal);
        reinicio = false;
      }
    }

    // 🚩 Validar horario solo si NO está 24h
    const horaInicio = tiempoActual;
    let horaFin = tiempoActual + tiempoTotal;
    if (!this.rodamiento24Horas && (estaFueraDeHorario(horaInicio) || estaFueraDeHorario(horaFin))) {
      const minutosParaLas5am = this.diferenciaDesde5am(tiempoActual);
      tiempoExtra = minutosParaLas5am - tramo.calculoTiempo;
      if (tiempoExtra < 0) tiempoExtra = 0;

      tiempoTotal = tramo.calculoTiempo + tiempoExtra;
      horaFin = tiempoActual + tiempoTotal;

      tramo.conDescanso = true;
      tramo.justificacion = `⏸️ Tramo ajustado para comenzar a las ${this.formatHoraMin(HORA_INICIO_JORNADA)} (fuera del horario de rodamiento ${this.formatHoraMin(HORA_INICIO_JORNADA)}-${this.formatHoraMin(HORA_FIN_JORNADA)})`;
      reinicio = false;
    }

    // Configurar propiedades del tramo
    tramo.horaIngreso = this.formatHoraMin(tiempoActual);
    tramo.horaSalida = this.formatHoraMin(tiempoActual + tiempoTotal);
    tramo.horaLlegada = tramo.horaSalida;
    tramo.ventanaHoraria = `${tramo.horaIngreso} - ${tramo.horaSalida}`;
    tramo.acumuladoInicio = formatHorasMin(tiempoLaboralAcumulado);
    tramo.acumuladoFinal = formatHorasMin(tiempoLaboralAcumulado + tramo.calculoTiempo);

    if (tramo.tipoParada !== "tarea") {
      tramo.indicadorConduccionInicioMin = tiempoConduccionAcumulado;
      tramo.indicadorConduccionInicioFmt = formatHorasMin(tiempoConduccionAcumulado);
      tramo.indicadorConduccionFinMin = tiempoConduccionAcumulado + tramo.calculoTiempo;
      tramo.indicadorConduccionFinFmt = formatHorasMin(tramo.indicadorConduccionFinMin);
    } else {
      tramo.indicadorConduccionInicioMin = tiempoConduccionAcumulado;
      tramo.indicadorConduccionInicioFmt = formatHorasMin(tiempoConduccionAcumulado);
      tramo.indicadorConduccionFinMin = tiempoConduccionAcumulado;
      tramo.indicadorConduccionFinFmt = formatHorasMin(tiempoConduccionAcumulado);
    }

    tramo.indicadorJornadaInicioMin = tiempoLaboralAcumulado;
    tramo.indicadorJornadaInicioFmt = formatHorasMin(tiempoLaboralAcumulado);
    tramo.indicadorJornadaFinMin = tiempoLaboralAcumulado + tiempoTotal;
    tramo.indicadorJornadaFinFmt = formatHorasMin(tramo.indicadorJornadaFinMin);

    tramo.indicadorSinDescansoInicioMin = tiempoSinDescanso;
    tramo.indicadorSinDescansoInicioFmt = formatHorasMin(tiempoSinDescanso);
    tramo.indicadorSinDescansoFinMin = tramo.conDescanso ? 0 : nuevoTiempoSinDescanso;
    tramo.indicadorSinDescansoFinFmt = formatHorasMin(tramo.indicadorSinDescansoFinMin);

    tramo.dia = diaActual;
    tramo.conductor = conductorActual;

    resultado.push(tramo);

    // Reset día si se excede la jornada
    if ((tiempoLaboralAcumulado + tiempoTotal) > MAX_TIEMPO_LABORAL) {
      diaActual++;
      tiempoActual = HORA_INICIO_JORNADA;
      tiempoConduccionAcumulado = 0;
      tiempoConduccionDiario = 0;
      tiempoLaboralAcumulado = 0;
      tiempoSinDescanso = 0;
    }

    if (tiempoLaboralAcumulado > 4 && (estaFueraDeHorario(horaInicio) || estaFueraDeHorario(horaFin))) {
      agregarTareasIniciales();
    }

    if (reinicio) {
      tiempoActual = horaFin;
      tiempoLaboralAcumulado += tiempoTotal;
      if (tramo.tipoParada !== "tarea") {
        tiempoConduccionAcumulado += tramo.calculoTiempo;
        tiempoConduccionDiario += tramo.calculoTiempo;
      }
      tiempoSinDescanso = tramo.conDescanso ? 0 : nuevoTiempoSinDescanso;
    }
  }

  return resultado;
}




 parseDuracionAMinutos(duracion: string): number {
  let minutos = 0;
  const matchHoras = duracion.match(/(\d+)\s*h/);
  const matchMinutos = duracion.match(/(\d+)\s*min/);

  if (matchHoras) {
    minutos += parseInt(matchHoras[1], 10) * 60;
  }
  if (matchMinutos) {
    minutos += parseInt(matchMinutos[1], 10);
  }
  return minutos;
}

formatHoraMin(minutosTotales: number): string {
  const horas = Math.floor(minutosTotales / 60) % 24;
  const minutos = minutosTotales % 60;

  const ampm = horas >= 12 ? 'PM' : 'AM';
  const horas12 = horas % 12 === 0 ? 12 : horas % 12;

  const paddedMin = minutos < 10 ? '0' + minutos : minutos;

  return `${horas12}:${paddedMin} ${ampm}`;
}


diferenciaDesde5am(min: number): number {
  const HORA_INICIO_JORNADA = this.horaAMinutos(this.horaInicioRodamiento);
  return min < HORA_INICIO_JORNADA
    ? HORA_INICIO_JORNADA - min
    : (24 * 60 - min) + HORA_INICIO_JORNADA;
}

obtenerMinutosDesdeTexto(texto: string): number {
  let total = 0;
  const match = texto.toLowerCase().match(/(?:(\d+)\s*h)?\s*(?:(\d+)\s*min)?/);
  if (match) {
    const horas = parseInt(match[1], 10) || 0;
    const minutos = parseInt(match[2], 10) || 0;
    total = horas * 60 + minutos;
  }
  return total;
}


  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + ''+ EXCEL_EXTENSION);
  }

getPeajesFormateado(): string {
  return this.totalPeajes.toLocaleString('es-CO'); // Ej: 26.600
}

calcularTotalesTramos(): void {
  this.totalDistanciaKm = 0;
  this.totalDuracionMin = 0;
  this.totalPeajes = 0;
  this.rutaGenerada = true
this.raddonId = this.generateRaddonId()
 this.resumenRuta.tramos.forEach(tramo => {
      // 🛣️ Distancia
      const km = parseFloat(tramo.distancia.replace(',', '.').replace(' km', '').trim());
      if (!isNaN(km)) {
        this.totalDistanciaKm += km;
      }

      // ⏱️ Duración (maneja "1h 6 min", "46 min", "2h", etc.)
      let duracionMin = 0;
      const dur = tramo.duracion.toLowerCase().trim();
      if (dur) {
        const match = dur.match(/(?:(\d+)\s*h)?\s*(?:(\d+)\s*min)?/);
        if (match) {
          const horas = parseInt(match[1], 10) || 0;
          const minutos = parseInt(match[2], 10) || 0;
          duracionMin += horas * 60 + minutos;
        }
      }
      this.totalDuracionMin += duracionMin;

      // 💰 Peaje
      const peaje = parseFloat(tramo.peaje);
      if (!isNaN(peaje)) {
        this.totalPeajes += peaje;
      }


      
    });

         this.transformarPeajesConsulta(this.listaPeajes)
}

getDuracionFormateada(): string {
  const salidaStr = this.getFechaHoraSalida();
  const llegadaStr = this.getFechaHoraLlegada();


  if (!salidaStr || !llegadaStr) {

    return '';
  }

  const salida = this.parseFecha(salidaStr);
  const llegada = this.parseFecha(llegadaStr);

  if (!salida || !llegada) {

    return '';
  }

  const diffMin = Math.round((llegada.getTime() - salida.getTime()) / 60000);
  if (diffMin < 0) {
    
    return '';
  }

  const horas = Math.floor(diffMin / 60);
  const minutos = diffMin % 60;

  let resultado = '';
  if (horas > 0 && minutos > 0) {
    resultado = `${horas}h ${minutos} min`;
  } else if (horas > 0) {
    resultado = `${horas}h`;
  } else {
    resultado = `${minutos} min`;
  }

  return resultado;
}


/**
 * Convierte una fecha en formato "dd/MM/yyyy HH:mm" o ISO en objeto Date válido.
 */
private parseFecha(fechaStr: string): Date | null {
  // Ejemplo de entrada: "mar, 29 jul 2025 4:00 AM"

  // Diccionarios de meses en español
  const meses: { [key: string]: number } = {
    'ene': 0, 'feb': 1, 'mar': 2, 'abr': 3, 'may': 4, 'jun': 5,
    'jul': 6, 'ago': 7, 'sep': 8, 'oct': 9, 'nov': 10, 'dic': 11,
  };

  try {
    const partes = fechaStr.split(' '); 
    // partes = ["mar,", "29", "jul", "2025", "4:00", "AM"]

    const dia = parseInt(partes[1], 10);
    const mes = meses[partes[2].toLowerCase()];
    const anio = parseInt(partes[3], 10);

    const [horaStr, minutoStr] = partes[4].split(':').map(Number);
    let hora = horaStr;
    const minutos = minutoStr;
    const ampm = partes[5].toUpperCase();

    if (ampm === 'PM' && hora < 12) hora += 12;
    if (ampm === 'AM' && hora === 12) hora = 0;

    const date = new Date(anio, mes, dia, hora, minutos);
    return isNaN(date.getTime()) ? null : date;
  } catch (e) {
    console.log('Error al parsear fecha:', fechaStr, e);
    return null;
  }
}





procesarRutaCompleta(puntos: PuntoRutaTramo[]): void {
  if (!puntos || puntos.length < 2) {
    this.mostrarError('Se requieren al menos dos puntos');
    return;
  }

  this.cargando = true;
  this.resumenRuta = null;
  this.listaPeajes = [];
  this.distanciaTotal = 0;

  let duracionTotal = 0;
  let peajesTotales: any[] = [];
  let tramosTotales: any[] = [];
   this.pasosTotales = [];

  const procesarTramo = (index: number) => {
    if (index >= puntos.length - 1) {
      // Finalizar: consolidar datos
      this.resumenRuta = {
        distance: (this.distanciaTotal / 1000).toFixed(1),
        duration: Math.round(duracionTotal / 60),
        tolls: peajesTotales.length,
        tramos: []
      };
      this.listaPeajes = peajesTotales;

     // 1. Generar tramos de tareas (si existen)
    const tareasDelPunto = this.destino.tareas;
    let tramosDeTareas: any[] = [];

    if (tareasDelPunto && tareasDelPunto.length > 0) {
      tramosDeTareas = tareasDelPunto.map(tarea => {
        // Calcular duración basada en horas y minutos
        const horas = tarea.horas || 0;
        const minutos = tarea.minutos || 0;
        let duracion = "";
   let duracionnumero = 0;
        if (horas > 0 && minutos > 0) {
          duracion = `${horas}h ${minutos}min`;
          duracionnumero=  (horas * 60) +  minutos
        } else if (horas > 0) {
          duracion = `${horas}h`;
                    duracionnumero=  (horas * 60) 
        } else if (minutos > 0) {
          duracion = `${minutos}min`;
        duracionnumero =  minutos 
        } else {
          duracion = "0 min"; // Valor por defecto
        }

        return {
          desde: tarea.titulo || `Tarea en Punto ${index + 1}`,
          hasta: tarea.detalle || "Ubicación específica",
          distancia: "0 km",
          duracion: duracion, // Usamos el string calculado
          duracionnumero: duracionnumero , // Usamos el string calculado
          tipo: "tarea",
          horas: horas,  // Opcional: guardar los valores numéricos por si acaso
          minutos: minutos
        };
      });
    }

           tramosTotales = [...tramosTotales, ...tramosDeTareas];

      console.log("Tramos tramosTotales", tramosTotales)

      this.procesarTopografiaYTramos(tramosTotales);
      this.pintarPasosDetallados(this.pasosTotales);
      this.cargando = false;
      return;
    }

    const origen = puntos[index].coordenadas;
    const destino = puntos[index + 1].coordenadas;

    this.obtenerRutaSegmento(origen, destino).then(dataHere => {
      this.distanciaTotal += dataHere.distancia;
      duracionTotal += dataHere.duracion;
      peajesTotales = peajesTotales.concat(dataHere.peajes);
           this.polylineHere =   this.polylineHere.concat(dataHere.polyline);
      console.log('dataHere:', dataHere);
      this.pintarTramoHereEnMapa(dataHere.polylinePoints);



      const puntosIntermedios = this.convertirPeajesAPuntosIntermedios(dataHere.peajes);

this.resumenTareasService.getRuta(origen, destino, puntosIntermedios).subscribe({
  next: resruta => {
    console.log('google resumenTareasService:', resruta);

    // 1. Generar tramos de tareas (si existen)
    const tareasDelPunto = puntos[index].tareas;
    let tramosDeTareas: any[] = [];

    if (tareasDelPunto && tareasDelPunto.length > 0) {
      tramosDeTareas = tareasDelPunto.map(tarea => {
        // Calcular duración basada en horas y minutos
        const horas = tarea.horas || 0;
        const minutos = tarea.minutos || 0;
        let duracion = "";
   let duracionnumero = 0;
        if (horas > 0 && minutos > 0) {
          duracion = `${horas}h ${minutos}min`;
          duracionnumero=  (horas * 60) +  minutos
        } else if (horas > 0) {
          duracion = `${horas}h`;
                    duracionnumero=  (horas * 60) 
        } else if (minutos > 0) {
          duracion = `${minutos}min`;
        duracionnumero =  minutos 
        } else {
          duracion = "0 min"; // Valor por defecto
        }

        return {
          desde: tarea.titulo || `Tarea en Punto ${index + 1}`,
          hasta: tarea.detalle || "Ubicación específica",
          distancia: "0 km",
          duracion: duracion, // Usamos el string calculado
          duracionnumero: duracionnumero , // Usamos el string calculado
          tipo: "tarea",
          descripcion: tarea.descripcion,
          responsable: tarea.responsable,
          costo: tarea.costo || 0,
          horas: horas,  // Opcional: guardar los valores numéricos por si acaso
          minutos: minutos
        };
      });
    }

    // 2. Insertar tramos de tareas + tramo principal
    if (resruta.tramos) {
      tramosTotales = [...tramosTotales, ...tramosDeTareas, ...resruta.tramos];
    } else {
      tramosTotales = [...tramosTotales, ...tramosDeTareas];
    }

    // 3. Procesar pasos detallados (si existen)
    if (resruta.pasosDetallados) {
      this.pasosTotales = this.pasosTotales.concat(resruta.pasosDetallados);
    }

    procesarTramo(index + 1);
  },
  error: err => {
    console.error('Error en tramo Google:', err);
    this.mostrarError('Error consultando el tramo en Google');
    this.cargando = false;
  }
});

    }).catch(errHere => {
      console.error('Error en tramo HERE:', errHere);
      this.mostrarError('Error consultando el tramo en HERE');
      this.cargando = false;
    });
  };

  procesarTramo(0);
}


private generarNombreArchivo(baseName: string): string {
  const now = new Date();
  
  // Formatear fecha como DD-MM-YYYY
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = now.getFullYear();
  
  // Formatear hora como HH-MM-SS
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  
  return `${baseName}_${day}-${month}-${year}_${hours}-${minutes}-${seconds}`;
}

private procesarTopografiaYTramos(tramos: any[]) {
  // Guardar una copia de los tramos originales para preservar todos los campos
  const tramosOriginales = [...tramos];
  
  this.resumenTareasService.analizarTopografiaTramos(tramos)
    .subscribe({
      next: (res) => {
        // Combinar los resultados con los datos originales
        const tramosCompletos = tramosOriginales.map((tramoOriginal, index) => ({
          ...tramoOriginal, // Todos los campos originales
          ...(res.tramosConTopografia[index] || {}), // Añade topografia y confianza
        }));

                console.log(" analizar tramosCompletos:", tramosCompletos);

        this.resumenRuta.tramos = this.agregarVentanasHorariasConDescanso(tramosCompletos);
        this.calcularTotalesTramos();
      },
      error: (err) => {
        console.error("Error al analizar topografía:", err);
        this.mostrarError("No se pudo analizar la topografía");
        // Opcional: Asignar los tramos originales sin análisis de topografía
        this.resumenRuta.tramos = this.agregarVentanasHorariasConDescanso(tramosOriginales);
        this.calcularTotalesTramos();
      }
    });
}

agregarTareaDestino() {
  this.destino = this.destino || {};
  this.destino.tareas = this.destino.tareas || [];

  this.destino.tareas.push({
    titulo: '',
    detalle: '',
    horas: 0,
    minutos: 0
  });

                  console.log("tramos   this.destino",    this.destino);
}


eliminarTareaDestino(index: number): void {
  if (this.destino.tareas && this.destino.tareas.length > index) {
    this.destino.tareas.splice(index, 1);
  }
}

private mostrarError(mensaje: string) {
  // Puedes usar un servicio de notificaciones en lugar de alert
  alert(mensaje);
}
  

 pintarTramoHereEnMapa(puntos: { lat: number; lng: number }[]): void {
  if (!this.googleMap || !puntos || puntos.length === 0) {
    return;
  }

  const polyline = new google.maps.Polyline({
    path: puntos,
    geodesic: true,
    strokeColor: '#00796B', // verde oscuro HERE
    strokeOpacity: 0.8,
    strokeWeight: 5
  });

  polyline.setMap(this.googleMap);
 
}


private obtenerRutaHereApi(origin: string, destination: string): Promise<any> {
  return new Promise((resolve, reject) => {
    // Construir URL sin parámetro via
    const url = `https://router.hereapi.com/v8/routes` +
      `?transportMode=truck` +
      `&origin=${origin}` +
      `&destination=${destination}` +
      `&return=summary,polyline,tolls` +
      `&apikey=${this.apiKeyHere}`;

    this.http.get(url).subscribe({
      next: (data: any) => {
        const route = data.routes[0];
        let allPolylinePoints: { lat: number; lng: number }[] = [];
        let allTolls: any[] = [];
        let totalDistance = 0;
        let totalDuration = 0;

        route.sections.forEach((section: any) => {
          // Decodificar polilínea
          const decoded = decode(section.polyline);
          const sectionPoints = decoded.polyline.map(([lat, lng]) => ({ lat, lng }));
          allPolylinePoints = [...allPolylinePoints, ...sectionPoints];

          // Sumar métricas
          totalDistance += section.summary.length;
          totalDuration += section.summary.duration;

          // Recolectar peajes
          if (section.tolls && section.tolls.length) {
            allTolls = [...allTolls, ...section.tolls];
          }
        });

        resolve({
          polylinePoints: allPolylinePoints,
          tolls: allTolls,
          totalDistance,
          totalDuration,
          routeData: data
        });
      },
      error: (err) => {
        console.error('Error en HERE API:', err);
        reject(new Error('Error al obtener ruta de HERE'));
      }
    });
  });
}

createConvexHull(points: google.maps.LatLngLiteral[]): google.maps.LatLngLiteral[] {
  if (points.length < 3) return points;

  const uniquePoints = Array.from(new Set(points.map(p => `${p.lat},${p.lng}`)))
    .map(p => {
      const [lat, lng] = p.split(',');
      return { lat: parseFloat(lat), lng: parseFloat(lng) };
    });

  const sorted = uniquePoints.sort((a, b) => a.lat === b.lat ? a.lng - b.lng : a.lat - b.lat);

  const crossProduct = (o, a, b) =>
    (a.lat - o.lat) * (b.lng - o.lng) - (a.lng - o.lng) * (b.lat - o.lat);

  const lower: google.maps.LatLngLiteral[] = [];
  for (const point of sorted) {
    while (lower.length >= 2 && crossProduct(lower[lower.length - 2], lower[lower.length - 1], point) < 0) {
      lower.pop();
    }
    lower.push(point);
  }

  const upper: google.maps.LatLngLiteral[] = [];
  for (const point of sorted.reverse()) {
    while (upper.length >= 2 && crossProduct(upper[upper.length - 2], upper[upper.length - 1], point) < 0) {
      upper.pop();
    }
    upper.push(point);
  }

  upper.pop();
  lower.pop();

  return lower.concat(upper);
}

private coloresTramos: string[] = [
  '#e6194b', // rojo fuerte
  '#3cb44b', // verde fuerte
  '#ffe119', // amarillo fuerte
  '#0082c8', // azul intenso
  '#f58231', // naranja
  '#911eb4', // púrpura fuerte
  '#f032e6', // magenta
  '#008080', // teal
  '#aa6e28', // marrón oscuro
  '#800000', // vino tinto
  '#808000', // oliva fuerte
  '#000080', // azul marino
  '#808080'  // gris medio
];


pintarPasosDetallados(pasosDetallados: any[]) {
  const bounds = new google.maps.LatLngBounds();

  if (this.polylineRuta) {
    this.polylineRuta.setMap(null);
  }

  for (let m of this.marcadoresGoogle) m.setMap(null);
  for (let t of this.tollMarkersGoogle) t.setMap(null);

  this.marcadoresGoogle = [];
  this.tollMarkersGoogle = [];

  for (let i = 0; i < pasosDetallados.length; i++) {
    const paso = pasosDetallados[i];
    const puntos = this.decodeGooglePolyline(paso.polyline || '');
    const color = this.getColorByIndex(i, pasosDetallados.length);

    // 🟢 Pintar la línea del paso
    const polyline = new google.maps.Polyline({
      path: puntos,
      geodesic: true,
      strokeColor: "#FF0000",
      strokeOpacity: 1.0,
      strokeWeight: 4
    });
    polyline.setMap(this.googleMap);
    this.marcadoresGoogle.push(polyline);

    for (let j = 0; j < puntos.length; j++) {
      bounds.extend(puntos[j]);
    }

    // 🟢 Crear geozona convexa
    const geozonaCoords = this.createConvexHull(puntos); // usa los puntos del polyline
    const geozona = new google.maps.Polygon({
      paths: geozonaCoords,
      strokeColor: color,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: color,
      fillOpacity: 0.3
    });
    geozona.setMap(this.googleMap);
    this.marcadoresGoogle.push(geozona);

    // 🟢 Crear contenido info
    var direccion = paso.direccion ? paso.direccion : 'No disponible';
    var instruccion = paso.html_instructions ? paso.html_instructions : 'Sin instrucciones';
    var distancia = paso.distance && paso.distance.text ? paso.distance.text : 'N/A';
    var duracion = paso.duration && paso.duration.text ? paso.duration.text : 'N/A';

    var content =
      '<div style="max-width: 250px;">' +
        '<strong>Dirección:</strong><br/>' + direccion + '<br/><br/>' +
        '<strong>Instrucción:</strong><br/>' + instruccion + '<br/><br/>' +
        '<strong>Distancia:</strong> ' + distancia + '<br/>' +
        '<strong>Duración:</strong> ' + duracion +
      '</div>';

    var infoWindow = new google.maps.InfoWindow();

    // 🟢 Marcador en start_location
    if (paso.start_location) {
      const markerStart = new google.maps.Marker({
        position: paso.start_location,
        map: this.googleMap,
        icon: {
          url: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'
        }
      });

      google.maps.event.addListener(markerStart, 'click', (function (contentCopy, markerCopy) {
        return function () {
          infoWindow.setContent(contentCopy);
          infoWindow.open(this.googleMap, markerCopy);
        };
      })(content, markerStart));

      this.marcadoresGoogle.push(markerStart);
      bounds.extend(paso.start_location);
    }

    // 🟢 Marcador en end_location
    if (paso.end_location) {
      const markerEnd = new google.maps.Marker({
        position: paso.end_location,
        map: this.googleMap,
        icon: {
          url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png'
        }
      });

      google.maps.event.addListener(markerEnd, 'click', (function (contentCopy, markerCopy) {
        return function () {
          infoWindow.setContent(contentCopy);
          infoWindow.open(this.googleMap, markerCopy);
        };
      })(content, markerEnd));

      this.marcadoresGoogle.push(markerEnd);
      bounds.extend(paso.end_location);
    }
  }

  // 🟡 Pintar peajes
  if (this.listaPeajes && this.listaPeajes.length) {
    for (let k = 0; k < this.listaPeajes.length; k++) {
      const peaje = this.listaPeajes[k];
      const locs = peaje && peaje.tollCollectionLocations;
      if (locs && locs.length > 0 && locs[0].location) {
        const loc = locs[0].location;
        const nombre = locs[0].name ? locs[0].name : 'Peaje';

        const marker = new google.maps.Marker({
          position: loc,
          map: this.googleMap,
          title: nombre,
          icon: {
            url: 'https://maps.google.com/mapfiles/ms/icons/yellow-dot.png'
          }
        });

        this.tollMarkersGoogle.push(marker);
        bounds.extend(loc);
      }
    }
  }

  this.googleMap.fitBounds(bounds);
}






getColorByIndex(index: number, total: number): string {
  return this.coloresTramos[index % this.coloresTramos.length];
}



private convertirPeajesAPuntosIntermedios(peajes: any[]): PuntoIntermedio[] {
  return peajes
    .filter(p =>
      p &&
      p.tollCollectionLocations &&
      p.tollCollectionLocations.length &&
      p.tollCollectionLocations[0] &&
      p.tollCollectionLocations[0].location
    )
    .map(p => {
      const lat = p.tollCollectionLocations[0].location.lat;
      const lng = p.tollCollectionLocations[0].location.lng;
      const peaje = (p.fares &&
                     p.fares.length &&
                     p.fares[0] &&
                     p.fares[0].price &&
                     typeof p.fares[0].price.value === 'number')
        ? p.fares[0].price.value
        : 0;

      return { lat, lng, peaje };
    });
}


  decodeGooglePolyline(encoded: string): { lat: number, lng: number }[] {
  let index = 0;
  const len = encoded.length;
  let lat = 0;
  let lng = 0;
  const coordinates = [];

  while (index < len) {
    let shift = 0;
    let result = 0;
    let byte: number;

    // Decode latitude
    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1F) << shift;
      shift += 5;
    } while (byte >= 0x20);
    const deltaLat = (result & 1) ? ~(result >> 1) : (result >> 1);
    lat += deltaLat;

    // Decode longitude
    shift = 0;
    result = 0;
    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1F) << shift;
      shift += 5;
    } while (byte >= 0x20);
    const deltaLng = (result & 1) ? ~(result >> 1) : (result >> 1);
    lng += deltaLng;

    coordinates.push({ lat: lat * 1e-5, lng: lng * 1e-5 });
  }

  return coordinates;
}

 loadRutas() {

    this.resumenTareasService.getRutasViajeros(localStorage.getItem("negocio"),localStorage.getItem("agencia")).subscribe({
      next: (response) => {
        this.rutas = response.rutas || [];
        this.pintarTodosLosPuntos();

      },
      error: (err) => {
        console.error('Error cargando rutas:', err);
 
      }
    });
  }

   pintarTodosLosPuntos() {
      this.clearRutasMarkers();
    this.clearMap();
    const bounds = new google.maps.LatLngBounds();

    this.rutas.forEach(ruta => {
      // Pintar origen
      if (ruta.origen_latitud && ruta.origen_longitud) {
        const origenLatLng = new google.maps.LatLng(ruta.origen_latitud, ruta.origen_longitud);
        this.crearMarcador(origenLatLng, ruta, 'origen');
        bounds.extend(origenLatLng);
      }

      // Pintar destino
      if (ruta.destino_latitud && ruta.destino_longitud) {
        const destinoLatLng = new google.maps.LatLng(ruta.destino_latitud, ruta.destino_longitud);
        this.crearMarcador(destinoLatLng, ruta, 'destino');
        bounds.extend(destinoLatLng);
      }

      // Pintar puntos intermedios
      if (ruta.punto_intermedio_1_latitud && ruta.punto_intermedio_1_longitud) {
        const puntoLatLng = new google.maps.LatLng(
          ruta.punto_intermedio_1_latitud,
          ruta.punto_intermedio_1_longitud
        );
        this.crearMarcador(puntoLatLng, ruta, 'intermedio');
        bounds.extend(puntoLatLng);
      }
    });

    if (!bounds.isEmpty()) {
      this.googleMap.fitBounds(bounds, { padding: 50 });
      
      // Ajustar zoom después de un pequeño retraso para evitar problemas
      setTimeout(() => {
        const zoom = this.googleMap.getZoom();
        if (zoom > 12) this.googleMap.setZoom(12);
        if (zoom < 6) this.googleMap.setZoom(6);
      }, 100);
    }
  }

  clearRutasMarkers() {
  // Eliminar solo los marcadores de rutas
  this.marcadoresRutas.forEach(marker => marker.setMap(null));
  this.marcadoresRutas = [];
}

    crearMarcador(position: google.maps.LatLng, ruta: any, tipo: 'origen' | 'destino' | 'intermedio') {
    // Configuración por tipo de marcador
    const config = {
      origen: {
        color: '#4285F4', // Azul Google
        label: 'O',
        title: `ORIGEN: ${ruta.origen}`,
        fecha: this.formatearFecha(ruta.hora_salida),
        textoExtra: 'SALIDA',
        hora: this.extraerHora(ruta.hora_salida)
      },
      destino: {
        color: '#EA4335', // Rojo Google
        label: 'D',
        title: `DESTINO: ${ruta.destino}`,
        fecha: this.formatearFecha(ruta.hora_llegada),
        textoExtra: 'LLEGADA',
        hora: this.extraerHora(ruta.hora_llegada)
      },
      intermedio: {
        color: '#FBBC05', // Amarillo Google
        label: '1',
        title: `PUNTO INTERMEDIO: ${ruta.punto_intermedio_1_direccion || 'Sin nombre'}`,
        fecha: '',
        textoExtra: 'INTERMEDIO',
        hora: ''
      }
    }[tipo];

    // Crear canvas para el marcador
    const canvas = document.createElement('canvas');
    const width = 80;  // Ancho del marcador
    const height = 50; // Alto del marcador
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d');
    
    if (context) {
      // Dibujar forma de banderín
      context.beginPath();
      context.moveTo(0, 15);
      context.lineTo(15, 0);
      context.lineTo(width - 1, 0);
      context.lineTo(width - 1, height - 15);
      context.lineTo(width - 15, height);
      context.lineTo(0, height);
      context.closePath();
      
      // Rellenar con color
      context.fillStyle = config.color;
      context.fill();
      
      // Borde blanco
      context.strokeStyle = '#FFFFFF';
      context.lineWidth = 2;
      context.stroke();
      
      // Texto de la fecha (parte superior)
      if (config.fecha) {
        context.fillStyle = '#FFFFFF';
        context.font = 'bold 10px Arial';
        context.textAlign = 'center';
        context.fillText(config.fecha, width/2, 13);
      }
      
      // Texto de la hora (parte media)
      if (config.hora) {
        context.fillStyle = '#FFFFFF';
        context.font = 'bold 11px Arial';
        context.textAlign = 'center';
        context.fillText(config.hora, width/2, 27);
      }
      
      // Texto principal (letra grande abajo)
      context.fillStyle = '#FFFFFF';
      context.font = 'bold 16px Arial';
      context.textAlign = 'center';
      context.fillText(config.label, width/2, height - 10);
    }

    // Contenido del tooltip
    const contentString = `
      <div style="padding: 12px; min-width: 280px; font-family: 'Roboto', Arial, sans-serif;">
        <div style="color: ${config.color}; font-weight: bold; font-size: 15px; margin-bottom: 8px; border-bottom: 1px solid #eee; padding-bottom: 6px;">
          ${config.title}
        </div>
        <div style="font-size: 13px; margin-bottom: 6px;">
          <strong>${config.textoExtra}:</strong> ${tipo === 'origen' ? ruta.hora_salida : tipo === 'destino' ? ruta.hora_llegada : 'N/A'}
        </div>
        <div style="font-size: 13px; margin-bottom: 6px;">
          <strong>Guía:</strong> ${ruta.guia}
        </div>
        ${tipo === 'destino' ? `
        <div style="font-size: 13px; margin-bottom: 4px;">
          <strong>Duración:</strong> ${ruta.duracion_total}
        </div>
        <div style="font-size: 13px;">
          <strong>Distancia:</strong> ${ruta.distancia_total}
        </div>
        ` : ''}
      </div>
    `;

    const marker = new google.maps.Marker({
      position,
      map: this.googleMap,
      title: config.title,
      icon: {
        url: canvas.toDataURL(),
        scaledSize: new google.maps.Size(width, height),
        anchor: new google.maps.Point(width/2, height)
      },
      optimized: false
    });

    const infoWindow = new google.maps.InfoWindow({
      content: contentString,
      maxWidth: 300
    });

    marker.addListener('click', () => {
      infoWindow.open(this.googleMap, marker);
      (marker as any).infoWindow = infoWindow;
    });

    this.markers.push(marker);
      this.marcadoresRutas.push(marker);
    return marker;
  }

    clearMap() {

    
    // Limpiar marcadores
    this.markers.forEach(marker => marker.setMap(null));
    this.markers = [];
    
 
  }

    // Helper functions
  formatearFecha(fechaCompleta: string): string {
    if (!fechaCompleta) return '';
    try {
      const fecha = new Date(fechaCompleta);
      return fecha.toLocaleDateString('es-CO', {
        day: '2-digit',
        month: 'short'
      }).replace('.', '').toUpperCase();
    } catch (e) {
      console.error('Error formateando fecha:', e);
      return '';
    }
  }

  extraerHora(fechaCompleta: string): string {
    if (!fechaCompleta) return '';
    try {
      const fecha = new Date(fechaCompleta);
      return fecha.toLocaleTimeString('es-CO', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      }).toLowerCase();
    } catch (e) {
      console.error('Error extrayendo hora:', e);
      return '';
    }
  }



}